import { Wallet, ArrowRightLeft, User } from "lucide-react";

const tabs = [
  { id: "receivables", label: "Recebíveis", icon: Wallet },
  { id: "anticipations", label: "Antecipações", icon: ArrowRightLeft },
  { id: "profile", label: "Dados", icon: User },
];

export const BottomNav = ({ activeTab, onTabChange }) => {
  return (
    <nav
      data-testid="bottom-nav"
      className="fixed bottom-0 left-0 right-0 z-50 backdrop-blur-xl bg-black/80 border-t border-white/10"
    >
      <div className="max-w-lg mx-auto flex items-center justify-around h-16 px-4">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            data-testid={`bottom-nav-${tab.id}`}
            onClick={() => onTabChange(tab.id)}
            className={`flex flex-col items-center gap-1 px-4 py-2 rounded-xl transition-colors min-w-[72px] ${
              activeTab === tab.id
                ? "text-blue-400"
                : "text-muted-foreground hover:text-foreground"
            }`}
          >
            <tab.icon className={`w-5 h-5 ${activeTab === tab.id ? "stroke-[2.5]" : ""}`} />
            <span className="text-[10px] font-semibold">{tab.label}</span>
          </button>
        ))}
      </div>
    </nav>
  );
};
